<template>
  <div class="content resize">
    <e-breadcrumbs />
    <h1 class="page_title">{{ $t('msg.CART010G010.011') }}</h1><!-- 화물추적 -->
    <form :key="formKey" id="frm" @submit.prevent="onSearchSubmit()">
      <input type="text" id="_temp" style="display:none;" /><!-- Enter 클릭시 submit 방지용 -->
      <div class="content_box mt10">
        <table class="tbl_search">
          <colgroup>
            <col class="wid60">
            <col class="wid200">
            <col class="wid260">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>{{ $t('msg.CART010G010.015') }}</th><!-- 조회 -->
              <td>
                <select id="" v-model="params.dtKnd" @change="changeSelectFuc()">
                  <option value="BL">{{ $t('msg.CART010G010.012') }}</option><!-- B/L No. -->
                  <!--<option value="CN">{{ $t('msg.CART010G010.013') }}</option>--><!-- Container No. -->
                  <option value="BK">{{ $t('msg.CART010G010.014') }}</option><!-- Booking No. -->
                </select>
              </td>
              <td class="pl0">
                <input
                  :key="params.dtKnd"
                  type="text"
                  v-model="params.blNo"
                  id="blNo"
                  :name="`cargoSearchKey_${params.dtKnd}`"
                  @input="checkValidationAll()"
                >
              </td>
              <td>
                <button type="submit" class="button blue sh">{{ $t('msg.CART010G010.055') }}</button>
              </td>
              <td v-if="searchFlag === 'Y'
                    && noDataFlag === 'N'
                    && lang === 'KOR'
                    && bookingInfo.spcShiprYn === 'Y'
                    && (params.dtKnd === 'BL' || params.dtKnd === 'BK')" style="float: right"
                  id="subscriptionBtn"
              >
                <a class="button blue sh" href="#" @click.prevent="openSubscriptionPopup()">구독</a> <!-- 구독 -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="searchFlag === 'Y' && noDataFlag === 'N'" class="content_box mt10">
        <!-- ===== [1854617] 상단 그리드 (기존 목록 테이블은 2026-09-28 삭제) ===== -->
        <!-- 검색 결과가 없으면(알림 후) 기존 목록 테이블처럼 헤더만 있는 빈 표를 보여준다 -->
        <div v-if="searchFlag === 'Y' && noDataFlag === 'N'" class="mt10">
          <p v-if="cntrList.length > 0" class="text_right font_medium">(E) Estimated&nbsp;&nbsp;<span class="color_red">(A) Actual</span></p>
          <table class="tbl_col mt5 th_pre_line" :class="{ tbl_compact: registryNo === 'Y' }">
            <colgroup>
              <!-- REGISTRY NO. 칸 유무에 따라 합계 100% 가 되도록 두 벌 (topGridColWidths) -->
              <col v-for="(w, widx) in topGridColWidths" :key="'topGridCol_' + widx" :style="{ width: w }">
            </colgroup>
            <thead>
              <tr>
                <th>{{ $t('msg.CART010G010.012') }}<br>{{ '(' + $t('msg.ONEX010T010.093') + ')' }}</th><!-- B/L No.(Status) -->
                <th>{{ $t('msg.CART010G010.014') }}</th><!-- Booking No. -->
                <th>{{ $t('msg.CART010G010.013') }}</th><!-- Container No. -->
                <th>{{ $t('msg.CART010G010.016') }}</th><!-- Size/Type -->
                <th>CGO</th>
                <th>{{ $t('msg.CART010G010.077') }}</th><!-- POL 공컨반출 -->
                <th>{{ $t('msg.CART010G010.078') }}</th><!-- POL 풀컨반입 -->
                <th>{{ $t('msg.CART010G010.079') }}</th><!-- Loading -->
                <th>{{ $t('msg.CART010G010.080') }}</th><!-- Discharging -->
                <th>{{ $t('msg.CART010G010.081') }}</th><!-- POD 풀컨반출 -->
                <th>{{ $t('msg.CART010G010.082') }}</th><!-- POD 공컨반입 -->
                <th v-show="registryNo === 'Y'">REGISTRY NO. </th><!-- PH 전용 -->
              </tr>
            </thead>
            <tbody>
              <tr v-if="cntrList.length > 0">
                <td>
                  {{ cntrList[0].blNo }}
                  <span v-if="cntrList[0].issueStatus !== '99'" class="label2 blue">{{ getIssueStatus(cntrList[0].issueStatus) }}</span>
                </td>
                <td class="td_left_line">{{ parseBkNo(cntrList[0].bkgNo) }}</td>
                <!-- 컨테이너 선택 UI. 선택을 바꾸면 현재 위치 단계바가 그 컨테이너 기준으로 다시 그려진다 -->
                <td class="td_left_line">
                  <!-- 컨테이너 갯수가 5개 이하일때 -->
                  <p v-for="(cvo, cidx) in cntrList" :key="'sumCntr_' + cidx" v-show="cntrList.length <= 5">
                    <span v-if="cvo.cntrNo == detailParams.cntrNo" class="cntrNo_area">{{ cvo.cntrNo }}</span>
                    <a v-else href="#" class="cntrNo_area link" @click.prevent="setCntrList(cvo.cntrNo, cidx)">{{ cvo.cntrNo }}</a>
                  </p>
                  <!-- 컨테이너 갯수가 5개 이상이면 SelectBox로 -->
                  <p v-if="cntrList.length > 5">
                    <select v-model="selectCntrNo" @change="setCntrList()">
                      <option v-for="(cvo, cidx) in cntrList" :key="'sumCntrOpt_' + cidx" :value="cvo.cntrNo">{{ cvo.cntrNo }}</option>
                    </select>
                  </p>
                </td>
                <!-- Size/Type·CGO 는 선택한 컨테이너 기준 (selectedCntr) -->
                <td class="td_left_line">{{ selectedCntr.cntrSzCd }} {{ selectedCntr.cntrTypCd }}</td>
                <td class="td_left_line">{{ getCgoTypNm(selectedCntr.shprVanYn, selectedCntr.cgoTypCd) }}</td>
                <td class="td_left_line">{{ isVepCgo ? '-' : fnCntRate(legSummary.polMtyOutCnt, legSummary.totCnt) }}</td>
                <td class="td_left_line">{{ isVepCgo ? '-' : fnCntRate(legSummary.polFulInCnt, legSummary.totCnt) }}</td>
                <td class="td_left_line">
                  <p v-if="legSummary.loadingEstDt" :class="legSummary.loadingActDt ? 'color_gray' : ''">{{ fnEaDateTime(legSummary.loadingEstDt, 'E') }}</p>
                  <p v-if="legSummary.loadingActDt" class="color_red">{{ fnEaDateTime(legSummary.loadingActDt, 'A') }}</p>
                </td>
                <td class="td_left_line">
                  <p v-if="legSummary.dischargingEstDt" :class="legSummary.dischargingActDt ? 'color_gray' : ''">{{ fnEaDateTime(legSummary.dischargingEstDt, 'E') }}</p>
                  <p v-if="legSummary.dischargingActDt" class="color_red">{{ fnEaDateTime(legSummary.dischargingActDt, 'A') }}</p>
                </td>
                <td class="td_left_line">{{ isVepCgo ? '-' : fnCntRate(legSummary.podFulOutCnt, legSummary.totCnt) }}</td>
                <td class="td_left_line">{{ isVepCgo ? '-' : fnCntRate(legSummary.podMtyInCnt, legSummary.totCnt) }}</td>
                <td v-show="registryNo === 'Y'" class="td_left_line">{{ summaryMrnNo }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ===== [1854617] Vessel Detail ===== -->
        <div v-if="searchFlag === 'Y' && noDataFlag === 'N' && legDetailList.length > 0" class="mt25">
          <!-- 제목(왼쪽)과 범례(오른쪽)를 표 바로 위 한 줄에 -->
          <div style="display: flex; justify-content: space-between; align-items: baseline;">
            <h2 class="content_title" style="margin-bottom: 0px !important;">[Vessel Detail]</h2>
            <p class="font_medium">(E) Estimated&nbsp;&nbsp;<span class="color_red">(A) Actual</span></p>
          </div>
          <!-- 열 폭을 고정해 긴 터미널명은 칸을 넓히지 않고 칸 안에서 줄바꿈되도록 table-layout:fixed.
               출발/도착 은 영문 헤더 'Departure' 가 좁은 화면에서도 칸 안에 들어가도록 84px, 터미널은 남는 폭 (vesselDetailColWidths) -->
          <table class="tbl_col mt5" style="table-layout:fixed;">
            <colgroup>
              <!-- 일본어·중국어 화면은 Reserve/Confirm 칸이 붙어 두 벌 (vesselDetailColWidths) -->
              <col v-for="(w, widx) in vesselDetailColWidths" :key="'vdCol_' + widx" :style="{ width: w }">
            </colgroup>
            <thead>
              <tr>
                <th>Seq</th>
                <th>{{ $t('msg.CART010G010.019') }}</th><!-- 선명/항차 -->
                <th>{{ $t('msg.CART010G010.017') }}</th><!-- 출발 -->
                <th>{{ $t('msg.CART010G010.083') }}</th><!-- 터미널 -->
                <th>{{ $t('msg.CART010G010.018') }}</th><!-- 도착 -->
                <th>{{ $t('msg.CART010G010.083') }}</th><!-- 터미널 -->
                <th>{{ $t('msg.CART010G010.084') }}</th><!-- Departure (Time) -->
                <th>{{ $t('msg.CART010G010.085') }}</th><!-- Arrival (Time) -->
                <th>{{ $t('msg.CART010G010.086') }}</th><!-- Berthing (Time) -->
                <th v-if="showReserveConfirm">{{ $t('msg.CART010G010.020') }}/<br>{{ $t('msg.CART010G010.021') }}</th><!-- Reserve / Confirm (일본어·중국어 화면 전용) -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(leg, lidx) in legDetailList" :key="'legDetail_' + lidx">
                <td>{{ leg.legSeq }}</td>
                <td class="td_left_line">{{ leg.vslNm }}</td>
                <!-- 출발/도착 : 5자리 코드를 배지로, 마우스오버 시 포트명 -->
                <td class="td_left_line">
                  <span v-if="leg.polPortCd" class="label blue md" :title="leg.polPortNm || null">{{ leg.polPortCd }}</span>
                </td>
                <!-- 터미널 : 열 너비를 넘으면 칸 안에서 줄바꿈해 전체를 표시 (2026-10-30, 이전엔 ... 말줄임) -->
                <td class="td_left_line td_wrap">{{ leg.polTrmlNm }}</td>
                <td class="td_left_line">
                  <span v-if="leg.podPortCd" class="label blue md" :title="leg.podPortNm || null">{{ leg.podPortCd }}</span>
                </td>
                <td class="td_left_line td_wrap">{{ leg.podTrmlNm }}</td>
                <td class="td_left_line">
                  <p v-if="leg.departureEstDt" :class="leg.departureActDt ? 'color_gray' : ''">{{ fnEaDateTime(leg.departureEstDt, 'E') }}</p>
                  <p v-if="leg.departureActDt" class="color_red">{{ fnEaDateTime(leg.departureActDt, 'A') }}</p>
                </td>
                <td class="td_left_line">
                  <p v-if="leg.arrivalEstDt" :class="leg.arrivalActDt ? 'color_gray' : ''">{{ fnEaDateTime(leg.arrivalEstDt, 'E') }}</p>
                  <p v-if="leg.arrivalActDt" class="color_red">{{ fnEaDateTime(leg.arrivalActDt, 'A') }}</p>
                </td>
                <!-- Berthing 은 Vessel 한정. 비대상 leg 은 공란이 아니라 '-' 로 해당없음을 표시 -->
                <td class="td_left_line">
                  <template v-if="leg.berthingTargetYn === 'N'">-</template>
                  <template v-else>
                    <p v-if="leg.berthingEstDt" :class="leg.berthingActDt ? 'color_gray' : ''">{{ fnEaDateTime(leg.berthingEstDt, 'E') }}</p>
                    <p v-if="leg.berthingActDt" class="color_red">{{ fnEaDateTime(leg.berthingActDt, 'A') }}</p>
                  </template>
                </td>
                <!-- Reserve/Confirm : 기존 목록 테이블과 같은 값 (목록 응답 confirmCd 를 %% 로 나눈 leg 순서) -->
                <td v-if="showReserveConfirm" class="td_left_line">
                  <span v-if="legConfirmCds[lidx] === '01'" class="label red md">{{ $t('msg.CART010G010.022') }}</span><!-- 선적미확정 -->
                  <span v-if="legConfirmCds[lidx] === '02'" class="label green md">{{ $t('msg.CART010G010.023') }}</span><!-- 선적확정 -->
                  <span v-if="legConfirmCds[lidx] === '03'" class="label gray md">{{ $t('msg.CART010G010.024') }}</span><!-- 선적예정 -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ===== [1854617] 신규 그리드 끝 ===== -->

        <p v-if="rsChVesselList.length > 0 && (bookingInfo.polCtrCd === 'JP' || bookingInfo.podCtrCd === 'JP')" class="txt_desc color_black">
          <span v-for="(vo, idx) in rsChVesselList" :key="'rsChvsList' + idx">
            {{ vo.logCont }} <br>
          </span>
        </p>

        <p v-if="searchFlag !== 'N'" class="txt_desc color_black">
          {{ $t('msg.CART010G010.025') }}<br>
          {{ $t('msg.CART010G010.026') }}<br>
          {{ $t('msg.CART010G010.027') }}<br>
          {{ $t('msg.CART010G010.028') }}<br>
          {{ $t('msg.CART010G010.071') }}
        </p>

        <!-- POD INFORMATION 안내·버튼: 양하국 일본 + 일본어 화면일 때만 (2026-10-29) -->
        <div v-if="bookingInfo.podCtrCd === 'JP' && lang === 'JPN'">
          <p class="txt_desc color_black">
            こちらのボタンから、A/Nについての問合せ先、実入りの搬出先、空バンの返却先などの詳細をご確認いただけます。
          </p>
          <a class="button blue sh" style="margin:5px;" href="#" @click.prevent="CargoTrackingJpPodInfoPopCall()">POD INFORMATION( A/N 発行 所 / CY )</a> <!-- 검색 -->
        </div>

        <div v-if="detailFlag === 'Y'" class="position_relative mt25">
          <div style="display: flex; align-items: center; margin-bottom: 8px;">
            <h2 class="content_title" style="display: inline-block; margin-bottom: 0px !important;">{{ $t('msg.CART010G010.029') }}</h2><!-- 현재 위치 -->
            <a v-if="cargoEyeShowYn === 'Y'" style="margin-left: 8px;" class="button blue sh" href="#" @click.prevent="openCargoEye()">{{ $t('msg.CART010G010.060') }}</a> <!-- 검색 -->
            <a v-if="rfTargetYn === 'Y'" style="margin-left: 8px;" class="button blue sh" href="#" @click.prevent="openRfDataInfoPop()">{{ $t('menu.MENU03.040') }}</a> <!-- 냉동 컨테이너 실시간 정보 -->
          </div>

          <span class="location_ico_update">{{ $t('msg.CART010G010.030') }} : {{ updateDate }}</span><!-- UPDATE -->
        </div>
        <!-- 현재 위치 -->
        <cargo-location-detail
          ref="loc"
          v-if="detailFlag === 'Y'"
          :detail-params="detailParams"
          :average-params="averageParams"
          :detail-date-list="detailDateList"
          :detail-list="detailList"
          :detail-inland-list="inlandList"
          :date-flag="dateFlag"
          :rank="rank"
          :lang="lang"
          :dly-ctr-cd="dlyCtrCd"
          :cy-cfs-yn="cyCfsYn"
          :inland-list-in="inlandListIn"
          :is-vep-cgo="isVepCgo"
        />
        <!-- 지도 관련 -->
        <cargo-vessel-location
          ref="map"
          v-if="detailFlag === 'Y' && showCargoEye() && isOpenCargoEye"
          :bl-no="detailParams.blNo"
        >
        </cargo-vessel-location>
        <h2 v-if="detailFlag === 'Y' && inlandList.length > 0" class="content_title">{{ $t('msg.CART010G010.031') }}</h2><!-- 내륙 이동 상세 정보 -->
        <table v-if="detailFlag === 'Y' && inlandList.length > 0" class="tbl_col mt10">
          <colgroup>
            <col style="width:20%">
            <col style="width:18%">
            <col style="width:44%">
            <col style="width:18%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.CART010G010.032') }}</th><!-- CONTAINER NUMBER -->
              <th>{{ $t('msg.CART010G010.033') }}</th><!-- EVENT NAME -->
              <th>{{ $t('msg.CART010G010.034') }}</th><!-- LOCATION -->
              <th>{{ $t('msg.CART010G010.035') }}</th><!-- TIME(KST) -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in inlandList" :key="item.seq">
              <td>{{ item.cntrNo }}</td>
              <td>{{ item.eventCd }}</td>
              <td class="text_left">{{ item.plcNm }}</td>
              <td>{{ item.plcDtm }}</td>
            </tr>
          </tbody>
        </table>

        <!-- 마감 정보 , 출항이후는 가리도록 설정-->
        <close-info
          ref="closeInfo"
          v-if="detailFlag === 'Y' && ( bookingInfo.etd > bookingInfo.toDay)"
          :parent-info="closeParams"
        />

        <!-- 팝업관련 -->
        <win-layer-pop>
          <component v-if="customComponent" :is="customComponent" :detail="detail" :ok-hidden="isHidden"
                     @close="closePoup"
          />
        </win-layer-pop>

        <win-layer-pop class="ongoing-rf-list-popup">
          <component v-if="popupComponent" :is="popupComponent" @close="closeRfPopup" @callback="popupCallback"
                     :parent-info="popupParams"
          />
        </win-layer-pop>

        <win-layer-pop class="subscription-pop">
          <component
            v-if="subscriptionPopupComponent"
            :is="subscriptionPopupComponent"
            @close="closeSubscriptionPopup"
            @callback="subscriptionPopupCallback"
            :parent-info="subscriptionPopupParams"
          />
        </win-layer-pop>
      </div>
      <!-- 조회결과 없음 : [1854617] 상단 그리드와 같은 헤더 -->
      <div v-if="searchFlag === 'Y' && noDataFlag === 'Y'">
        <table class="tbl_col mt10 th_pre_line">
          <colgroup>
            <col style="width:10%">
            <col style="width:9%">
            <col style="width:11%">
            <col style="width:6%">
            <col style="width:4%">
            <col style="width:7%">
            <col style="width:7%">
            <col style="width:14%">
            <col style="width:14%">
            <col style="width:9%">
            <col style="width:9%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.CART010G010.012') }}<br>{{ '(' + $t('msg.ONEX010T010.093') + ')' }}</th><!-- B/L No.(Status) -->
              <th>{{ $t('msg.CART010G010.014') }}</th><!-- Booking No. -->
              <th>{{ $t('msg.CART010G010.013') }}</th><!-- Container No. -->
              <th>{{ $t('msg.CART010G010.016') }}</th><!-- Size/Type -->
              <th>CGO</th>
              <th>{{ $t('msg.CART010G010.077') }}</th><!-- POL 공컨반출 -->
              <th>{{ $t('msg.CART010G010.078') }}</th><!-- POL 풀컨반입 -->
              <th>{{ $t('msg.CART010G010.079') }}</th><!-- Loading -->
              <th>{{ $t('msg.CART010G010.080') }}</th><!-- Discharging -->
              <th>{{ $t('msg.CART010G010.081') }}</th><!-- POD 풀컨반출 -->
              <th>{{ $t('msg.CART010G010.082') }}</th><!-- POD 공컨반입 -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="11">{{ $t('msg.CART010G010.056') }}</td><!-- No Data. -->
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
</template>

<script>
import cargo from '@/api/rest/trans/cargo'
import commons from '@/api/services/commons'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import { rootComputed } from '@/store/helpers'
import rfDg from '@/api/rest/trans/rfDg'
import schedule from '@/api/rest/schedule/schedule'

export default {
  name: 'CargoTracking',
  components: {
    EBreadcrumbs,
    EDateRangePicker: () => import('@/components/common/EDateRangePickerForOog'),
    EDatePicker: () => import('@/components/common/EDatePicker'),
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
    RfDataNotiPop: () => import('@/pages/trans/popup/RfDataNotiPop'),
    RfDataInfoPop: () => import('@/pages/trans/popup/RfDataInfoPop'),
    CargoTrackingSubscriptionPop: () => import('@/pages/trans/popup/CargoTrackingSubscriptionPop'),
    'close-info': () => import('@/components/trans/CloseInfo.vue'),
    'cargo-location-detail': () => import('@/pages/trans/CargoLocationDetail'),
    'cargo-map-detail': () => import('@/pages/trans/CargoMapDetail'),
    'cargo-vessel-location': () => import('@/pages/trans/CargoVesselLocation'),
    CargoTrackingJpPodInfoPop: () => import('@/pages/trans/popup/CargoTrackingJpPodInfoPop') /* JP pod tracking 정보 */
  },
  data: function () {
    return {
      // form 재마운트용 key (검색 후 증가시켜 Chrome 자동완성 학습 트리거)
      formKey: 0,
      customComponent: null,
      popupComponent: null,
      subscriptionPopupComponent: null,
      popupCallback: () => {},
      subscriptionPopupCallback: () => {},
      popupParams: {},
      subscriptionPopupParams: {},
      commonCodes: [],
      //검색여부 플래그
      searchFlag: 'N',
      //상세정보 플래그
      detailFlag: 'N',
      //로그인 안했을때 특정 Bl 검색시 No Data플래그
      noDataFlag: 'N',
      isLoginYn: 'N',
      //사이트별 언어설정
      lang: '',
      //검색조건
      params: {
        dtKnd: 'BL',
        blNo: ''
      },
      //상세로 넘기는 정보
      detailParams: {
        blNo: '',
        bkgNo: '',
        cntrNo: '',
        cntrTypCd: '',
        tsYn: '',
        rail: '',
        railCnt: 0,
        //상세에서 처음에 보여줄 내륙정보 셋팅 (마지막 LEG ETD/ETA 기준)
        inlandEta: '',
        inlandEtd: '',
        dlyCtrCd: ''
      },
      //상세 평균 이동거리 정보
      averageParams: {
        podPortNm: '',
        podPortCd: '',
        dlyPlcNm: '',
        icdCd: '',
        avgTnsDrtm: ''
      },
      //컨테이너 관련 정보
      convertList: [],
      selectCntrNo: '',
      //컨테이너 detail 관련 정보
      detailList: [],
      detailDateList: [],
      //검색한 containerList
      cntrList: [],
      selectCntrList: [],
      //마감 정보, 내륙 정보
      inlandList: [],
      inlandListIn: [],
      closeParams: {
        vslCd: '',
        voyNo: '',
        polPortCd: '',
        podPortCd: '',
        polCtrCd: '',
        polTrmlCd: '',
        menuCd: ''
      },
      //상세에서 rank 처리
      rank: 0,
      dateFlag: '',
      bookingInfo: {},
      scriptEl: null,
      isOpenCargoEye: false,
      relYn: true, // JamSin

      // 냉동 컨테이너 버튼 대상 정보
      rfTargetYn: 'N',
      cargoEyeShowYn: 'Y',
      vslLocation2: [],
      dlyCtrCd: '',
      cyCfsYn: '',
      rsChVesselList: [],
      registryNo: 'N',
      kmtcSpotNegoYn: 'N',

      // [1854617] 신규 그리드 (기존 테이블과 별개로 하단에 추가 표시)
      legDetailList: [],
      legSummary: {}
    }
  },
  computed: {
    ...rootComputed,
    // [1854617] REGISTRY NO.(MRN) 은 PH 기항 leg 에만 붙는다. leg 중 처음 나오는 값을 쓴다.
    summaryMrnNo: function () {
      const hit = this.legDetailList.find(leg => this.$ekmtcCommon.isNotEmpty(leg.mrnNo) && leg.mrnNo.trim() !== '')
      return hit ? hit.mrnNo.trim() : ''
    },
    // [1854617] 상단 그리드 열 너비. REGISTRY NO.(PH) 칸이 붙으면 12칸 합계가 100% 가 되도록 다른 칸을 줄인다
    // (11칸 100% 에 10% 를 더하면 브라우저가 비율대로 줄여 POL/POD 칸이 헤더 글자보다 좁아졌다)
    topGridColWidths: function () {
      return this.registryNo === 'Y'
        ? ['9%', '8%', '10%', '6%', '4%', '7%', '7%', '12%', '12%', '8%', '8%', '9%']
        : ['10%', '9%', '11%', '6%', '4%', '7%', '7%', '14%', '14%', '9%', '9%']
    },
    // [1854617 후속] 상단 그리드 Size/Type·CGO 는 선택한 컨테이너 기준 (기존 목록 테이블과 동일).
    // selectCntrNo 는 setCntrList 가 링크·셀렉트 모두에서 선택값으로 맞춘다. 같은 번호가 여러 행이면(Booking 조회의 Part B/L) 첫 행
    selectedCntr: function () {
      return this.cntrList.find(item => item.cntrNo === this.selectCntrNo) || this.cntrList[0] || {}
    },
    // [1854617 후속] Vessel Detail 의 Reserve/Confirm 칸은 일본어·중국어 화면에서만 (중국어 2026-10-29 추가)
    showReserveConfirm: function () {
      return this.lang === 'JPN' || this.lang === 'CHN'
    },
    // Reserve/Confirm 칸(12%)은 시각 칸에서 덜어 낸다(시각 칸 12% 는 날짜 한 줄 유지선). 일본어·중국어 헤더·배지 문구는 같은 영문
    // 출발/도착(포트 코드 배지) 은 84px 고정 : 영문 헤더 'Departure'(68px)+여백이 좁은 표(858px)에서도 들어가는 폭(09-29 요청)이라
    // 좁은 표에선 예전 10%(86px) 와 거의 같고, 넓은 표(1208px)에선 121px → 84px 로 줄어든다 (2026-10-30)
    // 터미널 두 칸은 폭을 비워(null) table-layout:fixed 규칙대로 나머지 폭을 똑같이 나눠 갖는다 → 줄인 폭이 줄바꿈되는 터미널명으로 간다
    vesselDetailColWidths: function () {
      return this.showReserveConfirm
        ? ['5%', '11%', '84px', null, '84px', null, '12%', '12%', '12%', '12%']
        : ['5%', '12%', '84px', null, '84px', null, '14%', '14%', '13%']
    },
    // 기존 목록 테이블(setCntrList)과 같은 소스 : SF_VO_002_GET_VSL_INFO 'CONFIRMCD' 를 %% 로 이은 값(leg 순서).
    // legDetailList 도 같은 B/L(cntrList[0].blNo)의 CS102I 를 LEG_SEQ 순으로 읽어 인덱스가 같다
    legConfirmCds: function () {
      const cd = this.cntrList.length > 0 ? this.cntrList[0].confirmCd : ''
      return this.$ekmtcCommon.isNotEmpty(cd) ? cd.split('%%') : []
    },
    // [1854617] CGO_MODE_CD 06(VEP) 이면 상단 그리드의 POL 공컨반출·풀컨반입 / POD 풀컨반출·공컨반입 을 '-' 로 표시
    isVepCgo: function () {
      return this.legSummary.cgoModeCd === '06'
    },
    updateDate: function () {
      let date = ''

      if (this.detailList.length > 0) {
        for (let i = 0; i < this.detailList.length; i++) {
          if (this.$ekmtcCommon.isEmpty(this.detailList[i].rkNext)) {
            date = this.$ekmtcCommon.changeDatePattern(this.detailList[i].mvntDt, '-')
          }
        }
      }

      return date
    },
    isEkmtc () {
      return sessionStorage.getItem('loginId').indexOf('EKMTC_') !== -1
    }
  },
  async created () {
    await this.init()
  },
  mounted () {
    this.$nextTick(function () {
      globalThis.addEventListener('keydown', this.handleKeydown)
    })
  },
  destroyed () {
    if (this.scriptEl !== null) {
      document.body.removeChild(this.scriptEl)
    }
    globalThis.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    async openRfDataInfoPop (e, page, gridIndex) {
      const params = {
        cntrList: this.cntrList,
        convertList: this.convertList,
        detailParams: this.detailParams,
        selectCntrList: this.selectCntrList,
        detailList: this.detailList,
        rank: this.rank,
        blNo: this.detailParams.blNo
      }

      this.callRfDataNotiPop(params)
    },
    async callRfDataNotiPop (params) {
      this.popupCallback = (p) => {
        this.closeRfPopup()
        this.callRfDataInfoPop(p)
      }

      this.openRfPopup('RfDataNotiPop', params)
    },
    async callRfDataInfoPop (params) {
      console.log(params)
      this.openRfPopup('RfDataInfoPop', params)
    },
    closeRfPopup () {
      this.popupParams = {}
      this.popupComponent = null
      this.popupCallback = () => {}
      this.$ekmtcCommon.layerClose('.ongoing-rf-list-popup')
    },
    closeSubscriptionPopup () {
      this.subscriptionPopupParams = {}
      this.subscriptionPopupComponent = null
      this.subscriptionPopupCallback = () => {}
      this.$ekmtcCommon.layerClose('.subscription-pop')
    },
    openRfPopup (compNm, params) {
      this.popupParams = params

      this.popupComponent = compNm
      this.$ekmtcCommon.layerOpen('.ongoing-rf-list-popup')
    },
    handleKeydown (e) {
      // JamSin
      if (this.relYn) {
        if (e.key === 'Enter') {
          this.getCargoCntrList()
        }
      }
    },
    parseBkNo (s) {
      if (this.$ekmtcCommon.isEmpty(s)) {
        return ''
      } else {
        return s.replace(/(<br>)/g, '\n')
      }
    },
    showCargoEye () {
      let cd = localStorage.getItem('service_ctrcd')
      return (cd !== null && cd !== 'IN')
    },
    async openCargoEye () {
      setTimeout(() => {
        this.isOpenCargoEye = !this.isOpenCargoEye
      }, 500)
    },
    // leg 날짜(polEtd/podEta) 중 가장 늦은 날짜가 31일 이상 지났거나 날짜가 없으면 Cargo Eye 버튼 숨김('N')
    getCargoEyeShowYn (cntrLegInfo) {
      const legDates = []
      for (let leg of cntrLegInfo) {
        if (this.$ekmtcCommon.isNotEmpty(leg.polEtd)) legDates.push(leg.polEtd)
        if (this.$ekmtcCommon.isNotEmpty(leg.podEta)) legDates.push(leg.podEta)
      }
      if (legDates.length === 0) return 'N'

      const maxDt = legDates.sort().pop() // 'YYYYMMDDHHmm'은 사전순 정렬 = 시간순 정렬
      const lastDate = new Date(
        Number(maxDt.substring(0, 4)),
        Number(maxDt.substring(4, 6)) - 1,
        Number(maxDt.substring(6, 8)),
        Number(maxDt.substring(8, 10) || 0),
        Number(maxDt.substring(10, 12) || 0)
      )
      const limitDate = new Date()
      limitDate.setDate(limitDate.getDate() - 31)
      return lastDate < limitDate ? 'N' : 'Y'
    },
    async init () {
      // 로그인여부 가져오기
      if (this.auth.userId) {
        this.isLoginYn = 'Y'
        await schedule.getKmtcSpotTarget('01').then((response) => {
          this.kmtcSpotNegoYn = response.data[0].kmtcSpotNegoYn
        })
      }

      // 언어 가져오기
      await this.settingLang()

      if (Object.keys(this.$route.query).length > 0) {
        const vo = this.$route.query

        if (vo != null) {
          this.params.blNo = vo.keyword

          if (vo.searchType === 'BOOKING') {
            this.params.dtKnd = 'BK'
          }
          if (vo.searchType === 'BL') {
            this.params.dtKnd = 'BL'
          }
          if (vo.searchType === 'CONTAINER') {
            this.params.dtKnd = 'CN'
          }
        }

        await this.getCargoCntrList()
      }

      //Event Cd 가져오기
      const arrCdId = ['WB014']
      this.commonCodes = await commons.getCommonsCodesCommon(arrCdId)
    },
    async settingLang () {
      //유저 serviceLang정보 가져오기
      if (this.auth.userId) {
        this.lang = this.serviceLang
      } else {
        this.lang = this.auth.serviceLang
      }
    },
    onSearchSubmit () {
      // form submit 시 호출 - 검색 실행 후 form 재마운트하여 Chrome 자동완성 학습 재가능 상태로
      this.getCargoCntrList()
      this.$nextTick(() => {
        this.formKey++
      })
    },
    async getCargoCntrList () {
      this.isOpenCargoEye = false

      if (Object.keys(this.$route.query).length > 0) {
        await this.$router.replace({ query: {} })
      }

      const params = this.params

      //플래그 초기화
      this.detailFlag = 'N'
      this.noDataFlag = 'N'
      this.searchFlag = 'N'
      this.rfTargetYn = 'N'
      // [1854617] 신규 그리드 초기화
      this.legDetailList = []
      this.legSummary = {}

      // 본사직원이면 버튼 오픈
      // if (this.auth.userId && this.isEkmtc) {
      //   this.rfTargetYn = 'Y'
      // }

      if (this.checkValidationAll()) {
        //로그인 없이 특정 Bl 넘버 조회시 No Data.
        if (this.isLoginYn === 'N' && (params.blNo === 'PNC2838803' || params.blNo === 'PNC2840780' || params.blNo === 'PNC2890557' || params.blNo === 'PNC2899521' || params.blNo === 'PNC2939180' || params.blNo === 'PNC2944001')) {
          this.noDataFlag = 'Y'
          this.searchFlag = 'Y'

          return
        }

        await cargo.getContainerList(this.params).then(res => {
          const data = res.data
          const cntrList = data.cntrList
          const rsforChVessel = data.rsforChVessel

          this.cntrList = []
          this.cntrList = cntrList
          this.rsChVesselList = rsforChVessel

          if (cntrList.length > 0) {
            //cntr가공
            this.selectCntrNo = cntrList[0].cntrNo
            this.setCntrList(cntrList[0].cntrNo)

            if (cntrList[0].polCtrCd === 'PH' || cntrList[0].podCtrCd === 'PH') {
              this.registryNo = 'Y'
            } else {
              this.registryNo = 'N'
            }
          } else {
            this.cntrList = []
            this.convertList = []
            if (data.useYn === 'N') {
              this.$ekmtcCommon.alertDefault(this.$t('msg.CART010G010.072')) //현재 검색 불가능 합니다. 잠시후 다시 시도해주세요.
            } else {
              this.$ekmtcCommon.alertDefault(this.$t('msg.CART010G010.051')) //검색 결과가 없습니다.
            }

            this.registryNo = 'N'
          }

          this.searchFlag = 'Y'
        })
      }
    },
    // [1854617] 신규 그리드 시각 표기. 예) '(E) 2026.04.02 14:00'
    // dt 는 YYYYMMDDHHMI(12자리 이상), flag 는 'E' 또는 'A'. 값이 없으면 빈칸.
    // (E)/(A) 가 둘 다 있으면 템플릿에서 2줄로 나눠 찍고, (E) 는 흐리게 처리한다.
    fnEaDateTime (dt, flag) {
      if (this.$ekmtcCommon.isEmpty(dt)) {
        return ''
      }

      const s = String(dt)

      if (s.length < 12) {
        return s.length >= 8 ? `(${flag}) ${s.substring(0, 4)}.${s.substring(4, 6)}.${s.substring(6, 8)}` : ''
      }

      return `(${flag}) ${s.substring(0, 4)}.${s.substring(4, 6)}.${s.substring(6, 8)} ${s.substring(8, 10)}:${s.substring(10, 12)}`
    },
    // [1854617] 진행 개수 표기. 예) '1 / 2'
    fnCntRate (done, total) {
      return `${Number(done || 0)} / ${Number(total || 0)}`
    },
    async setCntrList (cntrNo, cidx) {
      this.convertList = []
      this.detailParams = {}

      //select를 골라서 들어왔을경우
      if (this.$ekmtcCommon.isEmpty(cntrNo)) {
        cntrNo = this.selectCntrNo
      }
      // 링크로 고른 경우도 선택값을 맞춘다 — 상단 그리드 Size/Type·CGO(selectedCntr)가 이 값을 따른다
      this.selectCntrNo = cntrNo

      const cntrList = this.cntrList
      // 냉동 컨테이너 조회 버튼 조건 확인
      /* NEW IOT RF CHECK */
      cntrList.forEach(cntrItem => {
        if (cntrItem.iotCntrCnt > 0) {
          if (cntrItem.bkgShprCstNo === this.auth.cstCd || cntrItem.hcneCstNo === this.auth.cstCd || (this.auth.userId && this.isEkmtc)) {
            this.rfTargetYn = 'Y'
          }
        }
      })

      //[AS-IS] 1. 최초 하단에 보여줄 Detail처리는 컨테이너의 첫번째 정보
      //        2. %%로 묶여있는 여러개의 컨테이너 정보(TS로 묶여있는 정보)는 가공처리
      //          2-1. 컨테이너 리스트가 다섯개 이상이면 셀렉트로 보여준다.
      //          2-2. eta, etd에 대한 데이터의 가공이 필요하다 1. YYYY.MM.DD 2. 날짜 영문표기

      for (let i = 0; i < this.cntrList.length; i++) {
        if (this.cntrList[i].polPortNm !== undefined && (this.cntrList[i].polPortNm).indexOf('%%') > -1) {
          // if (this.cntrList[i].polPortNm.indexOf('%%') > -1) {

          this.convertList = this.cntrList.reduce((arr, vo, idx) => {
            if (arr === undefined) {
              arr = []
            }

            if (cntrNo === '' && idx !== 0) {
              return arr
            } else if (cntrNo !== '' && cntrNo !== vo.cntrNo) {
              return arr
            }

            const arrPolPortNm = vo.polPortNm.split('%%')
            const arrPodPortNm = vo.podPortNm.split('%%')
            const arrVslNm = vo.vslNm.split('%%')
            const arrEtd = vo.etd.split('%%')
            const arrEta = vo.eta.split('%%')
            const cnntDds = vo.cnntDds.split('%%')
            const trstDds = vo.trstDds.split('%%')
            const len = arrPolPortNm.length

            let etdImsi = ''
            let etaImsi = ''

            for (let i = 0; i < len; i++) {
              //2-2 eta, etd를 arr에 넣기전에 가공 => 000000000000일때와 ENG일때 가공 처리 - ENG일때는 홈페이지에서 바뀌는게 있는지 여부
              //    railCnt처리
              //    inland Eta, Etd 처리
              if (arrEtd[i] === '000000000000') {
                if (vo.polSchChk === 'A') {
                  etdImsi = this.$ekmtcCommon.getAddDayForTracking(arrEta[i - 1].substring(0, 8), Number.parseInt(cnntDds[i]))
                  arrEtd[i] = this.$ekmtcCommon.getAddDayForTracking(arrEta[i - 1].substring(0, 8), Number.parseInt(cnntDds[i])) + '1200'
                  arrEtd[i] = arrEtd[i].substring(0, 4) + '.' + arrEtd[i].substring(4, 6) + '.' + arrEtd[i].substring(6, 8) + '/' + arrEtd[i].substring(8, 10) + ':' + arrEtd[i].substring(10, 12)
                } else {
                  etdImsi = arrEtd[i].substring(0, 8)
                  arrEtd[i] = arrEtd[i].substring(0, 4) + '.' + arrEtd[i].substring(4, 6) + '.' + arrEtd[i].substring(6, 8) + '/' + arrEtd[i].substring(8, 10) + ':' + arrEtd[i].substring(10, 12)
                }
              }
              if (arrEta[i] === '000000000000') {
                if (vo.polSchChk === 'A') {
                  arrEta[i] = this.$ekmtcCommon.getAddDayForTracking(etdImsi.substring(0, 8), Number.parseInt(trstDds[i])) + '1200'
                  arrEta[i] = arrEta[i].substring(0, 4) + '.' + arrEta[i].substring(4, 6) + '.' + arrEta[i].substring(6, 8) + '/' + arrEta[i].substring(8, 10) + ':' + arrEta[i].substring(10, 12)
                } else {
                  etaImsi = arrEta[i].substring(0, 8)
                  arrEta[i] = arrEta[i].substring(0, 4) + '.' + arrEta[i].substring(4, 6) + '.' + arrEta[i].substring(6, 8) + '/' + arrEta[i].substring(8, 10) + ':' + arrEta[i].substring(10, 12)
                }
              }
              if (arrVslNm[i].indexOf('Rail') > -1) {
                this.detailParams.rail = 'Y'
                this.detailParams.railCnt = i
              }

              if (arrVslNm[len - 1].indexOf('Rail') > -1) {
                this.detailParams.icdRail = 'Y'
              }

              if (arrVslNm[len - 1].indexOf('Truckage') > -1) {
                this.detailParams.icdTruckage = 'Y'
              }

              //inland에 넣을 마지막값 넣기
              if (i === len - 1) {
                this.detailParams.inlandEta = arrEta[i]
                this.detailParams.inlandEtd = arrEtd[i]
              }

              arr.push({
                blNo: vo.blNo,
                bkgNo: vo.bkgNo,
                cntrNo: vo.cntrNo,
                cntrSzCd: vo.cntrSzCd,
                cntrTypCd: vo.cntrTypCd,
                polPortNm: arrPolPortNm[i],
                podPortNm: arrPodPortNm[i],
                vslNm: arrVslNm[i],
                etd: arrEtd[i].indexOf('/') > -1 ? arrEtd[i] : this.$ekmtcCommon.changeDatePattern(arrEtd[i]),
                eta: arrEta[i].indexOf('/') > -1 ? arrEta[i] : this.$ekmtcCommon.changeDatePattern(arrEta[i]),
                vslCd: vo.vslCd,
                voyNo: vo.voyNo,
                polTrmlCd: vo.polTrmlCd,
                polPortCd: vo.polPortCd,
                podPortCd: vo.podPortCd,
                polCtrCd: vo.polCtrCd,
                mapVslNm: arrVslNm[i].substring(2),
                mapEtd: arrEtd[i],
                mapEta: arrEta[i],
                cyCfsYn: vo.cyCfsYn,
                issueStatus: vo.issueStatus
              })
            }
            this.dlyCtrCd = vo.dlyCtrCd
            return arr
          }, [])
        } else {
          //%%가 없는 경우도 있으니 날짜형식 바꿔주기
          if (this.cntrList[i].eta !== undefined) {
            if (this.cntrList[i].eta.indexOf('-') < 0) {
              this.cntrList[i].eta = this.$ekmtcCommon.changeDatePattern(this.cntrList[i].eta, '-')
              this.cntrList[i].etd = this.$ekmtcCommon.changeDatePattern(this.cntrList[i].etd, '-')
            }
          }

          // 지도 위치 검색 데이터
          this.cntrList[i].mapVslNm = this.$ekmtcCommon.isNotEmpty(this.cntrList[i].vslNm) ? this.cntrList[i].vslNm.substring(2) : ''
          this.cntrList[i].mapEtd = this.$ekmtcCommon.isNotEmpty(this.cntrList[i].etd) ? this.cntrList[i].etd.replaceAll('-', '').replaceAll(':', '').split(' ').join('') : ''
          this.cntrList[i].mapEta = this.$ekmtcCommon.isNotEmpty(this.cntrList[i].eta) ? this.cntrList[i].eta.replaceAll('-', '').replaceAll(':', '').split(' ').join('') : ''

          this.dlyCtrCd = this.cntrList[i].dlyCtrCd
        }
      }

      this.cyCfsYn = this.cntrList[0].cyCfsYn

      // 선박위치 버튼 노출 여부(cntrEtdEtaList) + [1854617] 상단 그리드·Vessel Detail 데이터
      // (기존 목록 테이블용 legEtd/legEta/mrnNo 세팅과 leg별 도착 터미널명 조회는 테이블 삭제와 함께 제거)
      await cargo.getCntrEtdEtaInfo(this.cntrList[0].blNo).then(res => {
        this.cargoEyeShowYn = this.getCargoEyeShowYn(res.data.cntrEtdEtaList)
        this.legDetailList = res.data.legDetailList || []
        this.legSummary = res.data.legSummary || {}
      })

      let covParams = ''
      let cntrDataList = this.convertList.length > 0 ? this.convertList : new Array(this.cntrList[0])
      let cntrBlNo = this.convertList.length > 0 ? this.convertList[0].blNo : this.cntrList[0].blNo

      for (let vsl of cntrDataList) {
        let chkAis = true
        let vslNm = vsl.mapVslNm.split('/')[0].trim()

        if (vslNm === 'Truckage' || vslNm === 'Truck' || vslNm === 'Rail' || vslNm === 'XIANGFU2') {
          chkAis = false
        }

        if (chkAis) {
          covParams += vsl.mapVslNm + ':'
        }
      }

      if (this.$ekmtcCommon.isEmpty(cidx)) {
        let filtered = this.cntrList.filter((item) => item.cntrNo === this.selectCntrNo)

        if (filtered.length > 0) {
          this.selectCntrList = filtered
        }
      }

      if (this.cntrList.length > 0) {
        //부킹정보 가져오기
        let tmpBkgNo = this.cntrList[0].bkgNo
        let paramBkg = ''
        // 부킹이 연결되지 않은 컨테이너는 bkgNo가 없어 조회할 수 없으므로 건너뛴다.
        if (this.$ekmtcCommon.isNotEmpty(tmpBkgNo)) {
          if (!tmpBkgNo.includes('<br>')) {
            paramBkg = tmpBkgNo.split('<br>')[0]
          } else {
            paramBkg = tmpBkgNo
          }
          await this.getBookingInfo(paramBkg)
        }
      }
      //마감정보 가져오기
      //this.getCloseInfo()

      // 선택한 컨테이너의 상세정보를 가져온다.
      if (this.$ekmtcCommon.isNotEmpty(cntrNo)) {
        await this.getCargoCntrDetail(cntrNo)
      }
    },
    async getCargoCntrDetail (cntrNo) {
      this.detailFlag = 'N'
      const detailParams = this.detailParams
      let tmpBlNo = ''
      let tmpBkgNo = ''
      let tmpTsYn = ''
      let tmpCntrTypCd = ''
      let tmpPorPlcCd = ''
      let tmpPolPortCd = ''
      let tmpPodPortCd = ''
      let tmpDlyPlcCd = ''
      let list = this.cntrList

      list.forEach(item => {
        if (item.cntrNo === cntrNo) {
          tmpBlNo = item.blNo
          tmpBkgNo = item.bkgNo || '' // 부킹이 연결되지 않은 컨테이너는 bkgNo가 없음
          tmpTsYn = item.tsYn
          tmpCntrTypCd = item.cntrTypCd
          tmpPorPlcCd = item.porPlcCd || '' // 수취지(POR) - 수출 반입풀 단계 라벨 판정용
          tmpPolPortCd = item.polPortCd || '' // 선적항(POL)
          tmpPodPortCd = item.podPortCd || '' // 양하항(POD) - ICD 내륙 운송 문구 판정용
          tmpDlyPlcCd = item.dlyPlcCd || '' // 인도지(DLY)
        }
      })

      detailParams.dtKnd = this.params.dtKnd
      // 상세정보 할당하기
      detailParams.blNo = tmpBlNo
      if (!tmpBkgNo.includes('<br>')) {
        detailParams.bkgNo = tmpBkgNo.split('<br>')[0]
        detailParams.strBkgNo = tmpBkgNo.split('<br>').join(';')
      } else {
        detailParams.bkgNo = tmpBkgNo
        detailParams.strBkgNo = tmpBkgNo
      }
      detailParams.cntrNo = cntrNo
      detailParams.tsYn = tmpTsYn
      detailParams.cntrTypCd = tmpCntrTypCd
      detailParams.porPlcCd = tmpPorPlcCd
      detailParams.polPortCd = tmpPolPortCd
      detailParams.blPodPortCd = tmpPodPortCd
      detailParams.blDlyPlcCd = tmpDlyPlcCd

      // Vue2는 객체에 새로 추가한 프로퍼티를 감지하지 못하므로, 객체를 교체해 선택된 컨테이너 표시에 반영한다.
      this.detailParams = { ...detailParams }

      // 상세(이동이력)는 B/L 또는 부킹 중 하나로 조회되므로, 둘 다 없으면 조회를 건너뛴다.(현재 위치 영역 비노출)
      if (this.$ekmtcCommon.isEmpty(tmpBlNo) && this.$ekmtcCommon.isEmpty(tmpBkgNo)) {
        return
      }

      // console.log('detaillParams @@@@@', detailParams)
      await cargo.getContainerDetail(detailParams).then(res => {
        // console.log(res)

        // 초기화
        this.detailList = []
        this.inlandListIn = []
        this.detailDateList = []
        this.inlandList = []
        this.averageParams = {}
        this.dateFlag = ''
        this.rank = 0
        this.inlandEta = ''
        this.inlandEtd = ''

        // 할당
        this.detailList = [...res.data.trackingList, ...res.data.inlandListIn]
        this.inlandListIn = res.data.inlandListIn

        this.detailList.sort((a, b) => {
          return b.rk - a.rk
        })

        this.detailDateList = res.data.dtVo
        this.dateFlag = res.data.dateFlag

        // trackingList의 가장 최신 rk 값으로 변경
        this.rank = this.detailList.length > 0 && this.$ekmtcCommon.isNotEmpty(this.detailList[0].rk) ? this.detailList[0].rk : res.data.rank

        if (res.data.inlandList.length > 0) {
          this.inlandList = res.data.inlandList

          // 내륙정보는 초기 5개만 보여주기 (5개부터는 Junction Crossed(21)와 ICD Crossed(20) 보여주기)
          if (this.inlandList.length > 5) {
            let tmpInlandList = this.inlandList.splice(5)

            tmpInlandList.forEach(item => {
              if (item.eventCd === '20' || item.eventCd === '21') {
                this.inlandList.push(item)
              }
            })
          }

          //내륙시간 가공
          const tmpCommEventList = this.commonCodes.WB014

          if (tmpCommEventList !== undefined && tmpCommEventList !== null) {
            for (let j = 0; j < this.inlandList.length; j++) {
              this.inlandList[j].plcDtm = this.$ekmtcCommon.changeDatePattern(this.inlandList[j].plcDtm, '-')
              this.inlandList[j].eventCd = this.getEventName(this.inlandList[j].eventCd)
            }
          }

          this.inlandList = this.inlandList.reverse()
        }

        if (this.$ekmtcCommon.isNotEmpty(res.data.averageInfo)) {
          this.averageParams = res.data.averageInfo

          // 평균시간 가공
          this.averageParams.avgTnsDrtm = this.$ekmtcCommon.makeDateForm(this.averageParams.avgTnsDrtm)
        }
      })

      this.detailFlag = 'Y'
    },
    getCgoTypNm (shprVanYn, cgoTypCd) {
      const nmMap = { '01': 'HZ', '02': 'OOG', '03': 'ING', '05': 'NOR', '06': 'FB' }

      if (shprVanYn === 'Y') {
        if (cgoTypCd === '01') return 'S\'VAN + HZ'
        return nmMap[cgoTypCd] ? `${nmMap[cgoTypCd]} + S'VAN` : 'S\'VAN'
      }
      return nmMap[cgoTypCd] || ''
    },
    //이벤트 명 가져오기
    getEventName (cd) {
      let catNm = 'X'
      if (this.$ekmtcCommon.isNotEmpty(cd)) {
        this.commonCodes.WB014.forEach((item) => {
          if (item.cd === cd) {
            catNm = item.cdNm
          }
        })
      }
      return catNm
    },
    async getBookingInfo (bkgNo) {
      await cargo.getBookingClose(bkgNo).then(res => {
        this.bookingInfo = res.data

        this.getCloseInfo()
      }).catch(err => {
        console.log(err)
        this.$ekmtcCommon.alertDefault(this.$t('js.common.005')) // 조회에 실패했습니다. 관리자에게 문의해주세요.
      })
    },
    //마감정보에 필요한 정보 가져오기
    async getCloseInfo () {
      //podCtrCd, podPlcCd, polCtrCd, polPlcCd, menuCd("03" 고정),
      //vslCd, voyNo, rteCd, ctrCd, trmlCd, optrCd, closInfCd("01" 고정)
      //closeInfo에 넘길 parentInfo정보

      if (this.convertList.length > 0) {
        this.closeParams.vslCd = this.convertList[0].vslCd
        this.closeParams.voyNo = this.convertList[0].voyNo
        this.closeParams.polPortCd = this.convertList[0].polPortCd
        this.closeParams.podPortCd = this.convertList[0].podPortCd
        this.closeParams.polCtrCd = this.convertList[0].polCtrCd
        this.closeParams.polTrmlCd = this.convertList[0].polTrmlCd
        this.closeParams.bound = 'O'
        this.closeParams.menuCd = '03'
      } else {
        this.closeParams.vslCd = this.cntrList[0].vslCd
        this.closeParams.voyNo = this.cntrList[0].voyNo
        this.closeParams.polPortCd = this.cntrList[0].polPortCd
        this.closeParams.podPortCd = this.cntrList[0].podPortCd
        this.closeParams.polCtrCd = this.cntrList[0].polCtrCd
        this.closeParams.polTrmlCd = this.cntrList[0].polTrmlCd
        this.closeParams.bound = 'O'
        this.closeParams.menuCd = '03'
      }

      this.closeParams.bkgDocCls = this.$ekmtcCommon.changeDatePattern(this.bookingInfo.docCls, '.')
      this.closeParams.bkgCgoCls = this.$ekmtcCommon.changeDatePattern(this.bookingInfo.cgoCls, '.')
      this.closeParams.bkgMfCls = this.$ekmtcCommon.changeDatePattern(this.bookingInfo.mfCls, '.')
      this.closeParams.cfsCls = this.$ekmtcCommon.changeDatePattern(this.bookingInfo.cfsCls, '.')
      this.closeParams.callSign = this.bookingInfo.callSign || ''
      this.closeParams.mrnNo = this.bookingInfo.mrnNo || ''
      //this.closeParams = { ...this.bookingInfo }

      //rte코드 가져오기
      await cargo.getRtnCode(this.closeParams).then(res => {
        if (res.status === 200) {
          this.closeParams.rteCd = res.data
        }
      })
    },
    checkValidationAll () {
      this.params.blNo = this.params.blNo.toUpperCase().trim()
      let isAllOk = true
      const frm = document.querySelector('#frm')
      const selector = frm.querySelector('#blNo')

      this.$ekmtcCommon.hideErrorTooltip(selector)

      // 검색어 체크
      // if (this.$ekmtcCommon.isEmpty(selector.value)) {
      if (this.$ekmtcCommon.isEmpty(this.params.blNo)) {
        if (this.params.dtKnd === 'BL') {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CART010G010.052')) // Bl No.를 확인하세요.
          isAllOk = false
        } else if (this.params.dtKnd === 'BK') {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CART010G010.053')) // Booking No.를 확인하세요.
          isAllOk = false
        } else {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CART010G010.054')) // Container No.를 확인하세요.
          isAllOk = false
        }
      }

      return isAllOk
    },
    changeSelectFuc () {
      this.params.blNo = ''
    },
    CargoTrackingJpPodInfoPopCall () {
      const params = {
        podPortCd: this.bookingInfo.podPortCd,
        podTrmlCd: this.bookingInfo.podTrmlCd,
        podCtrCd: this.bookingInfo.podCtrCd,
        vslCd: this.bookingInfo.vslCd,
        blNo: this.bookingInfo.blNo
      }

      this.openRfPopup('CargoTrackingJpPodInfoPop', params)
    },
    openSubscriptionPopup () {
      //로그인 체크
      if (this.auth.login) {
        if (this.bookingInfo.bkgShprCstNo !== this.memberDetail.cstCd) {
          this.$ekmtcCommon.alertDefault('해당 BOOKING의 BOOKING SHIPPER가 아닙니다.')
          return
        }
      } else {
        this.$parent.$parent.$children[0].$children[0].changeLoginBoxStatus()
        return
      }

      const params = {
        podPortCd: this.bookingInfo.podPortCd,
        podPortNm: this.bookingInfo.podPortEnm,
        podTrmlCd: this.bookingInfo.podTrmlCd,
        podCtrCd: this.bookingInfo.podCtrCd,
        polPortCd: this.bookingInfo.polPortCd,
        polPortNm: this.bookingInfo.polPortEnm,
        polTrmlCd: this.bookingInfo.polTrmlCd,
        polCtrCd: this.bookingInfo.polCtrCd,
        vslCd: this.bookingInfo.vslCd,
        bkgNo: this.bookingInfo.bkgNo,
        cntrList: this.cntrList
      }

      this.subscriptionPopupParams = params

      this.subscriptionPopupComponent = 'CargoTrackingSubscriptionPop'
      this.$ekmtcCommon.layerOpen('.subscription-pop')
    },
    getIssueStatus (issueStatus) {
      const msgKeyMap = {
        11: 'msg.ONEX010T010.094', // O.B/L 재발행
        '01': 'msg.ONEX010T010.094',
        16: 'msg.ONEX010T010.094',
        '06': 'msg.ONEX010T010.097', // O.B/L 발행중
        '04': 'msg.ONEX010T010.097',
        '02': 'msg.ONEX010T010.095', // Surrender 발행
        17: 'msg.ONEX010T010.095',
        '07': 'msg.ONEX010T010.101', // Surrender 처리중
        42: 'msg.ONEX010T010.105', // 취소
        46: 'msg.ONEX010T010.105',
        '03': 'msg.ONEX010T010.096', // S/Waybill 발행
        14: 'msg.ONEX010T010.096',
        88: 'msg.ONEX010T010.109', // 발행불가
        89: 'msg.ONEX010T010.110', // Pending
        99: '' // 요청불가
      }

      const msgKey = msgKeyMap[issueStatus]
      return msgKey ? this.$t(msgKey) : msgKey
    }
  }
}
</script>

<style scoped>
.td_left_line {
  border-left: 1px solid #e1e3eb !important;
}

.nodrag {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  background-color: #adadad;
  border: 1px;
  border-color: #000;
  padding: 5px 8px 5px 8px;
}

.label2-add {
  display: inline !important;
}

/* [1854617] 상단 그리드 헤더 : 다국어 문구의 \n(예: 'POL\n공컨반출')을 줄바꿈으로 표시하고,
   좁은 칸에서도 '공컨반출' 같은 단어가 중간에서 쪼개지지 않게 한다 */
.th_pre_line th {
  white-space: pre-line;
  word-break: keep-all;
}

/* [1854617] REGISTRY NO. 칸이 붙으면(12칸) 좁은 화면에서 칸 최소폭 합(887px)이 배경 영역(858px)을 넘으므로
   좌우 여백 5px → 3px 로 줄인다 (합 839px) */
.tbl_compact th,
.tbl_compact td {
  padding-left: 3px;
  padding-right: 3px;
}

/* [1854617] Vessel Detail 터미널 : 띄어쓰기에서 먼저 줄바꿈하고, 칸보다 긴 한 단어(예: 'TAL.URAN,DIST.RAIGAD.TEL.65104')만
   글자 단위로 끊어 옆 칸으로 넘치지 않게 한다 (word-wrap 은 구형 브라우저용 별칭) */
.td_wrap {
  overflow-wrap: break-word;
  word-wrap: break-word;
}
</style>
